module.exports = __webpack_public_path__ + "img/Group 127@2x.17d1f34b.png";